import { Vue as _Vue } from 'vue/types/vue'
import { VueModule } from 'vue-modules'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'
import { TokenService } from '@/modules/core/services/auth/token.service'
import NotFoundComponent from '@/modules/site/components/NotFoundComponent.vue'

export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (TokenService.getToken() == null) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export class RouterModule implements VueModule {
  readonly name = 'router';
  router?: Router;
  install (Vue: typeof _Vue) {
    Vue.use(Router)

    this.router = router

    Vue.use(
      VueAnalytics, {
        id: 'UA-150380207-1',
        debug: { // disable analytics in develop
          sendHitTask: process.env.NODE_ENV === 'production'
        },
        router // auto page discovery
      })
  }
}
